/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/models/emailEntryDto"/>

export type EmailEntryDto = {
    id: string;
    emailType: EmailType;
    senderName: string;
    timestamp: Date;
    emailStatus: EmailStatus;
    recipients: EmailRecipientEntryDto[];
};

export enum EmailType
{
    SendToSupplier = 0,
    SendInvoiceImage = 1,
}

export type EmailRecipientEntryDto = {
    emailAddress: string;
    type: RecipientType;
    emailStatus: EmailStatus;
    latestEventReason?: string;
    latestEventType?: EmailEventType;
};

export type RecipientType = 'To' | 'Cc' | 'Bcc';

export const EMAIL_EVENT_TYPES = {
    Delivered: 'delivered',
    Bounced: 'bounced',
    Dropped: 'dropped',
    Deferred: 'deferred',
    Other: 'other',
} as const;

export type EmailEventType = typeof EMAIL_EVENT_TYPES[keyof typeof EMAIL_EVENT_TYPES];

export const EMAIL_STATUSES = {
    HollowGreen: 'hollowGreen',
    Green: 'green',
    Amber: 'amber',
    HollowRed: 'hollowRed',
    Red: 'red',
} as const;

export type EmailStatus = typeof EMAIL_STATUSES[keyof typeof EMAIL_STATUSES];
